import React from "react"
import InformationPopover from "components/Shared/InformationPopover"
import "./card.scss"
import { CardTypeConfig } from "./domain"
import { CardType } from "./constants"
import { TreeMap } from "./treemap"
import { Pie } from "./pie"
import { Bar } from "./bar"

interface CardProps {
	title: string
	description: string
	data: Array<any>
	cardType: CardType
	colorPalette: any
	informationPopoverTitle?: string
	informationPopoverText?: string
}

export const Card: React.FC<CardProps> = ({
	title,
	description,
	data,
	cardType,
	colorPalette,
	informationPopoverTitle,
	informationPopoverText,
}) => {
	const cardConfigs: Record<CardType, CardTypeConfig> = {
		[CardType.TREE_MAP]: {
			content: <TreeMap data={data} colorPalette={colorPalette} />,
		},
		[CardType.PIE_CHART]: {
			content: <Pie data={data} colorPalette={colorPalette} />,
		},
		[CardType.HORIZONTAL_BAR_CHART]: {
			content: <Bar data={data} colorPalette={colorPalette} />,
		},
	}

	return (
		<div className="card_container">
			<div className="card-title font-24 bold">
				{title}
				{(informationPopoverTitle || informationPopoverText) && (
					<InformationPopover
						title={informationPopoverTitle}
						text={informationPopoverText}
						width="22.5rem"
					/>
				)}
			</div>
			<div className="card-description">{description}</div>
			<div className="card-data">{cardConfigs[cardType].content}</div>
		</div>
	)
}
